import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysScoreRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [score, history] = await Promise.all([
      this.reimaginedData.fetchCareerCapitalScore(),
      this.reimaginedData.fetchScoreHistory(12),
    ]);

    return { score, history };
  }
}
